import axios from "axios";
import {  MessageBox,
  Message} from "element-ui";
import qs from "qs";
import { encrypt } from "@/utils/encryption";
import Config from "@/config/BaseConfigs";
const service = axios.create({
  baseURL: Config.serverUrl,
  timeout: 10000, // request timeout
});
axios.defaults.withCredentials = true;
// request interceptor
service.interceptors.request.use(
  (config) => {
    if (config.method === "post") {
      let res = qs.stringify(encrypt(config.data));
      config.data = res;
    }
    return config;
  },
  (error) => {
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.success !== true) {
      if (res.message == "noLoginMessage") {
        Message({
          message:'登录超时或未登录或异地登录，请重新登录系统！'
        });
        return res
      } else {
        Message({
          message:res.message || "Error"
        });
        return Promise.reject(new Error(res.message || 'Error'))
      }
    } else {
      return res
    }
  },
  (error) => {
    Message({
      message:error.message
    })
    return Promise.reject(error);
  }
);

export default service;
